import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "flex w-full flex-col items-center gap-2 text-center" };
const _hoisted_2 = { class: "flex flex-col items-center gap-0.5" };
const _hoisted_3 = ["id"];
const _hoisted_4 = { class: "text-base leading-6 text-(--colors-text-black-default)" };
const _hoisted_5 = {
    key: 0,
    "data-testid": "manage-access-loading",
    "aria-busy": "true",
    class: "flex flex-col gap-4"
};
const _hoisted_6 = {
    key: 1,
    class: "flex flex-col gap-4"
};
const _hoisted_7 = {
    key: 0,
    "data-testid": "manage-access-load-error",
    role: "alert",
    class: "text-sm leading-5 text-(--text-text-error-strong)"
};
const _hoisted_8 = {
    key: 2,
    "data-testid": "manage-access-error",
    role: "alert",
    class: "text-sm leading-5 text-(--text-text-error-strong)"
};
import { computed, ref, useId, watch } from "vue";
import { Modal, Button, IconShape, FieldSkeleton } from "@eudonet/opal";
import FilterSharingFields from "@/shared/components/advanced-filter-library/FilterSharingFields.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ManageFilterAccessModal',
    props: {
        modelValue: { type: Boolean },
        sharing: {},
        knownUsers: {},
        loading: { type: Boolean },
        loadError: { type: Boolean },
        busy: { type: Boolean },
        errorMessage: {}
    },
    emits: ["update:modelValue", "save"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const titleId = useId();
        // Placeholder only: the fields are not rendered while the grants are loading or unreadable.
        const emptySharing = () => ({ destination: "personal", access: { organization: null, users: [] } });
        const draft = ref(props.sharing ?? emptySharing());
        watch(() => props.sharing, (sharing) => {
            draft.value = sharing ?? emptySharing();
        });
        const canSave = computed(() => props.sharing !== null && !props.loading && !props.loadError && !props.busy);
        function onSubmit() {
            if (canSave.value)
                emit("save", draft.value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                "model-value": props.modelValue,
                size: "md",
                "footer-position": "split",
                "aria-labelledby": _unref(titleId),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (emit('update:modelValue', $event)))
            }, {
                header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_unref(IconShape), {
                            size: "lg",
                            type: "square",
                            variant: "outlined",
                            color: "white",
                            icon: "ri-lock-line"
                        }),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("h4", {
                                id: _unref(titleId),
                                class: "text-xl font-bold leading-6 text-(--colors-text-heading)"
                            }, _toDisplayString(_ctx.$t("advancedFilterLibrary.access.manage.title")), 9 /* TEXT, PROPS */, _hoisted_3),
                            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("advancedFilterLibrary.access.manage.subtitle")), 1 /* TEXT */)
                        ])
                    ])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        "data-testid": "manage-access-cancel",
                        variant: "secondary",
                        label: _ctx.$t('advancedFilterLibrary.save.cancel'),
                        disabled: props.busy,
                        onClick: _cache[1] || (_cache[1] = ($event) => (emit('update:modelValue', false)))
                    }, null, 8 /* PROPS */, ["label", "disabled"]),
                    _createVNode(_unref(Button), {
                        "data-testid": "manage-access-submit",
                        variant: "primary",
                        "icon-left": "ri-save-3-fill",
                        label: _ctx.$t('advancedFilterLibrary.save.submit'),
                        loading: props.busy,
                        disabled: !canSave.value,
                        onClick: onSubmit
                    }, null, 8 /* PROPS */, ["label", "loading", "disabled"])
                ]),
                default: _withCtx(() => [
                    (props.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_unref(FieldSkeleton)),
                            _createVNode(_unref(FieldSkeleton))
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (props.loadError)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t("advancedFilterLibrary.access.manage.loadError")), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                            (!props.loadError)
                                ? (_openBlock(), _createBlock(FilterSharingFields, {
                                    key: 1,
                                    modelValue: draft.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((draft).value = $event)),
                                    "known-users": props.knownUsers,
                                    disabled: props.busy
                                }, null, 8 /* PROPS */, ["modelValue", "known-users", "disabled"]))
                                : _createCommentVNode("v-if", true),
                            (props.errorMessage)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(props.errorMessage), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                        ]))
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["model-value", "aria-labelledby"]));
        };
    }
});
